import React from 'react';
import {
  Detail,
  Avatar,
  PresenceDot,
  DetailName,
  DetailRole,
  StatGrid,
  StatCard,
  IconButton,
  HeaderActions,
} from './styles';
import { initialsOf, lastSeenLabel, avatarColor } from './helpers';
import { CloseIcon } from './icons';

const DetailPanelV2 = ({ conversation, onClose }) => {
  if (!conversation) return null;
  const { user, isGroup, otherMemberPresence, otherMemberLastSeenAt } = conversation;
  const online = otherMemberPresence === 'online';

  return (
    <Detail>
      <HeaderActions style={{ alignSelf: 'flex-end', marginInlineStart: 0 }}>
        <IconButton type="button" onClick={onClose} title="Close">
          <CloseIcon size={18} />
        </IconButton>
      </HeaderActions>

      <Avatar
        src={user?.avatar}
        bg={avatarColor(user?.id || user?.name).bg}
        fg={avatarColor(user?.id || user?.name).fg}
        size="9rem"
      >
        {!user?.avatar && initialsOf(user?.name)}
        {!isGroup && <PresenceDot online={online} />}
      </Avatar>
      <DetailName>{user?.name}</DetailName>
      <DetailRole>
        {isGroup ? 'Group' : online ? 'Online now' : lastSeenLabel(otherMemberLastSeenAt)}
      </DetailRole>

      <StatGrid>
        <StatCard>
          <div className="value">{conversation.messageCount ?? 0}</div>
          <div className="label">Messages</div>
        </StatCard>
        <StatCard>
          <div className="value">{conversation.unreadMessageCount || 0}</div>
          <div className="label">Unread</div>
        </StatCard>
        {!isGroup && (
          <StatCard className="full">
            <div className="value">{conversation.otherMemberConversationCount ?? 0}</div>
            <div className="label">Total conversations</div>
          </StatCard>
        )}
      </StatGrid>
    </Detail>
  );
};

export default DetailPanelV2;
